let messageIds = 0;
export class PromiseWorker {
    constructor(worker) {
        this.worker = worker;
        this.callbacks = new Map();
        worker.addEventListener('message', (evt) => this.onMessage(evt.data));
    }
    onMessage(message) {
        if (!Array.isArray(message) || message.length < 2) {
            // Ignore - this message is not for us.
            return;
        }
        const [messageId, error, result] = message;
        const callback = this.callbacks.get(messageId);
        if (!callback) {
            // Ignore - user might have created multiple PromiseWorkers.
            // This message is not for us.
            return;
        }
        this.callbacks.delete(messageId);
        callback(error, result);
    }
    postMessage(userMessage) {
        const messageId = messageIds++;
        const messageToSend = [messageId, userMessage];
        return new Promise((resolve, reject) => {
            this.callbacks.set(messageId, (error, result) => {
                if (error)
                    reject(error);
                else
                    resolve(result);
            });
            this.worker.postMessage(messageToSend);
        });
    }
}
//# sourceMappingURL=promise-worker.js.map